export const GET_ACCOUNT_INFORMATION = 'GET_ACCOUNT_INFORMATION';
export const getAccountInformation = (shouldShowNotification = true) => ({
  type: GET_ACCOUNT_INFORMATION,
  shouldShowNotification,
});

export const GET_ACCOUNT_INFORMATION_SUCCESS = 'GET_ACCOUNT_INFORMATION_SUCCESS';
export const getAccountInformationSuccess = (accountInformation) => ({
  type: GET_ACCOUNT_INFORMATION_SUCCESS,
  accountInformation,
});
